const TOKEN_LIKE_PATTERN =
  /(bearer\s+[a-z0-9\-._~+/]+=*|eyJ[A-Za-z0-9._-]+|sk_[A-Za-z0-9]{16,}|pk_[A-Za-z0-9]{16,})/gi;

export function redactTokenLikeValue(input: string): string {
  return input.replace(TOKEN_LIKE_PATTERN, '[REDACTED]');
}
